export class ViewApplicationDetailsRcConstants {
    static STEP_TITLE = "Details";
    // Labels and headers
    static DESCRIPTION_LBL = "Description";
    static TYPE_LBL = "Application type";
    static REASON_FOR_APPLICATION = "Reason for application";
    static TYPE_OF_TRANSFER_LABEL = "Type of transfer";
    static PROPERTY_TYPE_LABEL = "Property type";
    static RATES_ACCOUNT_NUMBER_LABEL = "Rates account number";
    static ELECTRONIC_REFERENCE_LABEL = "Electronic reference number";
    static ATTORNEY_REFERENCE_LABEL = "Attorney reference";
    static COUNCIL_REFERENCE_LABEL = "Council reference";
    // Form control name
    static DESCRIPTION_CTRL = "description";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static TYPE_CTRL = "applicationType";
    static APPLICATION_PLACE_HOLDER = "Application place holder";
    static REASON_FOR_APPLICATION_CONTROL_NAME = "reasonForApplication";
    static TYPE_OF_TRANSFER_CONTROL_NAME = "typeOfTransfer";
    static PROPERTY_TYPE_CONTROL_NAME = "propertyType";
    static RATES_ACCOUNT_NUMBER_CONTROL_NAME = "ratesAccountNumber";
    static ELECTRONIC_REFERENCE_CONTROL_NAME = "electronicReference";
    static ATTORNEY_REFERENCE_CONTROL_NAME = "attorneyReference";
    static COUNCIL_REFERENCE_CONTROL_NAME = "councilReference";
}
